/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RecoverRouteImport } from './routes/recover'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppActivityRouteImport } from './routes/_app/activity'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppInventoryRouteImport } from './routes/_app/inventory'
import { Route as AppRulesRouteImport } from './routes/_app/rules'
import { Route as AppSecurityRouteImport } from './routes/_app/security'
import { Route as AppDevicesIndexRouteImport } from './routes/_app/devices/index'
import { Route as AppDevicesEnrollRouteImport } from './routes/_app/devices/enroll'
import { Route as AppFilesIndexRouteImport } from './routes/_app/files/index'
import { Route as AppFilesFileIdRouteImport } from './routes/_app/files/$fileId'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppProjectsProjectIdRouteImport } from './routes/_app/projects/$projectId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoverRoute = RecoverRouteImport.update({
  id: '/recover',
  path: '/recover',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppActivityRoute = AppActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryRoute = AppInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRoute,
} as any)
const AppRulesRoute = AppRulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => AppRoute,
} as any)
const AppSecurityRoute = AppSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesIndexRoute = AppDevicesIndexRouteImport.update({
  id: '/devices/',
  path: '/devices/',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesEnrollRoute = AppDevicesEnrollRouteImport.update({
  id: '/devices/enroll',
  path: '/devices/enroll',
  getParentRoute: () => AppRoute,
} as any)
const AppFilesIndexRoute = AppFilesIndexRouteImport.update({
  id: '/files/',
  path: '/files/',
  getParentRoute: () => AppRoute,
} as any)
const AppFilesFileIdRoute = AppFilesFileIdRouteImport.update({
  id: '/files/$fileId',
  path: '/files/$fileId',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/recover': typeof RecoverRoute
  '/signup': typeof SignupRoute
  '/activity': typeof AppActivityRoute
  '/admin': typeof AppAdminRoute
  '/inventory': typeof AppInventoryRoute
  '/rules': typeof AppRulesRoute
  '/security': typeof AppSecurityRoute
  '/devices/enroll': typeof AppDevicesEnrollRoute
  '/files/$fileId': typeof AppFilesFileIdRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/devices/': typeof AppDevicesIndexRoute
  '/files/': typeof AppFilesIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/recover': typeof RecoverRoute
  '/signup': typeof SignupRoute
  '/activity': typeof AppActivityRoute
  '/admin': typeof AppAdminRoute
  '/inventory': typeof AppInventoryRoute
  '/rules': typeof AppRulesRoute
  '/security': typeof AppSecurityRoute
  '/': typeof AppIndexRoute
  '/devices/enroll': typeof AppDevicesEnrollRoute
  '/files/$fileId': typeof AppFilesFileIdRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/devices': typeof AppDevicesIndexRoute
  '/files': typeof AppFilesIndexRoute
  '/projects': typeof AppProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/recover': typeof RecoverRoute
  '/signup': typeof SignupRoute
  '/_app/activity': typeof AppActivityRoute
  '/_app/admin': typeof AppAdminRoute
  '/_app/inventory': typeof AppInventoryRoute
  '/_app/rules': typeof AppRulesRoute
  '/_app/security': typeof AppSecurityRoute
  '/_app/': typeof AppIndexRoute
  '/_app/devices/enroll': typeof AppDevicesEnrollRoute
  '/_app/files/$fileId': typeof AppFilesFileIdRoute
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/_app/devices/': typeof AppDevicesIndexRoute
  '/_app/files/': typeof AppFilesIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/recover'
    | '/signup'
    | '/activity'
    | '/admin'
    | '/inventory'
    | '/rules'
    | '/security'
    | '/devices/enroll'
    | '/files/$fileId'
    | '/projects/$projectId'
    | '/devices/'
    | '/files/'
    | '/projects/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/recover'
    | '/signup'
    | '/activity'
    | '/admin'
    | '/inventory'
    | '/rules'
    | '/security'
    | '/'
    | '/devices/enroll'
    | '/files/$fileId'
    | '/projects/$projectId'
    | '/devices'
    | '/files'
    | '/projects'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/recover'
    | '/signup'
    | '/_app/activity'
    | '/_app/admin'
    | '/_app/inventory'
    | '/_app/rules'
    | '/_app/security'
    | '/_app/'
    | '/_app/devices/enroll'
    | '/_app/files/$fileId'
    | '/_app/projects/$projectId'
    | '/_app/devices/'
    | '/_app/files/'
    | '/_app/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  RecoverRoute: typeof RecoverRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recover': {
      id: '/recover'
      path: '/recover'
      fullPath: '/recover'
      preLoaderRoute: typeof RecoverRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/activity': {
      id: '/_app/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AppActivityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory': {
      id: '/_app/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AppInventoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rules': {
      id: '/_app/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof AppRulesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/security': {
      id: '/_app/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof AppSecurityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices/': {
      id: '/_app/devices/'
      path: '/devices'
      fullPath: '/devices/'
      preLoaderRoute: typeof AppDevicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices/enroll': {
      id: '/_app/devices/enroll'
      path: '/devices/enroll'
      fullPath: '/devices/enroll'
      preLoaderRoute: typeof AppDevicesEnrollRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/files/': {
      id: '/_app/files/'
      path: '/files'
      fullPath: '/files/'
      preLoaderRoute: typeof AppFilesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/files/$fileId': {
      id: '/_app/files/$fileId'
      path: '/files/$fileId'
      fullPath: '/files/$fileId'
      preLoaderRoute: typeof AppFilesFileIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppActivityRoute: typeof AppActivityRoute
  AppAdminRoute: typeof AppAdminRoute
  AppInventoryRoute: typeof AppInventoryRoute
  AppRulesRoute: typeof AppRulesRoute
  AppSecurityRoute: typeof AppSecurityRoute
  AppIndexRoute: typeof AppIndexRoute
  AppDevicesEnrollRoute: typeof AppDevicesEnrollRoute
  AppFilesFileIdRoute: typeof AppFilesFileIdRoute
  AppProjectsProjectIdRoute: typeof AppProjectsProjectIdRoute
  AppDevicesIndexRoute: typeof AppDevicesIndexRoute
  AppFilesIndexRoute: typeof AppFilesIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppActivityRoute: AppActivityRoute,
  AppAdminRoute: AppAdminRoute,
  AppInventoryRoute: AppInventoryRoute,
  AppRulesRoute: AppRulesRoute,
  AppSecurityRoute: AppSecurityRoute,
  AppIndexRoute: AppIndexRoute,
  AppDevicesEnrollRoute: AppDevicesEnrollRoute,
  AppFilesFileIdRoute: AppFilesFileIdRoute,
  AppProjectsProjectIdRoute: AppProjectsProjectIdRoute,
  AppDevicesIndexRoute: AppDevicesIndexRoute,
  AppFilesIndexRoute: AppFilesIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  RecoverRoute: RecoverRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
